import { DatePicker } from '@formily/antd';
import { createSchemaComponent } from '../../shared';
export default createSchemaComponent({
    componentName: 'DatePicker.RangePicker',
    component: DatePicker,
});
